import { render, staticRenderFns } from "./Rate.vue?vue&type=template&id=29c1aac8&scoped=true"
import script from "./Rate.vue?vue&type=script&lang=js"
export * from "./Rate.vue?vue&type=script&lang=js"
import style0 from "./Rate.vue?vue&type=style&index=0&id=29c1aac8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c1aac8",
  null
  
)

export default component.exports